<div>
	<nha-popup [isOpen]="popupOpen()" [isClick]="true" (openChanged)="popupOpen.set($event)">
		<nha-chip [icon]="isSelected() ? 'check' : ''" iconSize="18px" popup-target [color]="isSelected() ? 'blue' : 'clear'" [text]="filterTitle()"></nha-chip>

		<div popup-content class="filter-chip-popup-container">
			<div class="filter-header">
				<span class="title">{{ groupTitle() }}</span>
				<button mat-icon-button matTooltip="Close Filter" type="button" (click)="popupOpen.set(false)">
					<mat-icon>close</mat-icon>
				</button>
			</div>

			<div class="filter-chip-list">
				@for (filter of filters(); track filter.key) {
					<span class="title">{{ filter.value.title }}</span>

					<nha-filter-chip-content [key]="key()" [filterKey]="filter.key" [filter]="filter.value" [counts]="counts()"> </nha-filter-chip-content>
				}
			</div>
		</div>
	</nha-popup>
</div>
